var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-contaniner"},[_c('div',{staticClass:"nav-left"},[_c('CompanySelect')],1),_vm._v(" "),_c('div',{staticClass:"nav-center"},[_c('UpgradePrompt')],1),_vm._v(" "),_c('div',{staticClass:"nav-right"},[_vm._t("navbar"),_vm._v(" "),_c('personal-center')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }